/**
 * returnTo query-param validation shared by the login, signup, and auth-callback
 * pages.
 *
 * Only same-origin relative paths are accepted, preventing open redirects:
 *   - must start with "/"
 *   - must not start with "//" (protocol-relative URL → foreign origin)
 *   - must not start with "/\" (some browsers normalize backslash to slash)
 */
export function sanitizeReturnTo(raw: string | null): string | null {
  if (!raw) {
    return null;
  }
  if (!raw.startsWith('/')) {
    return null;
  }
  if (raw.startsWith('//') || raw.startsWith('/\\')) {
    return null;
  }
  return raw;
}

/** Append a validated returnTo to a path, preserving it across auth pages. */
export function withReturnTo(path: string, returnTo: string | null): string {
  if (!returnTo) {
    return path;
  }
  return `${path}?returnTo=${encodeURIComponent(returnTo)}`;
}
